import React, { useEffect } from 'react';
import { Card, List, Row, Col, Image } from 'antd';
import { Link } from 'react-router';
import { useQuery } from '@apollo/client';
import { queries } from '../../graphql/graphql';
import { MapUserResultsData, MapResult } from '../../types/plans';
import { useAuth } from '../../providers/AuthProvider';
import { Loader } from '../../components/UI/Loader';

const imageStyle: React.CSSProperties = {
  aspectRatio: '1 / 1',
  objectFit: 'cover',
  width: '100%',
};

export const MyPlansList: React.FC = () => {
  const { user } = useAuth();

  const { data, loading, refetch } = useQuery<MapUserResultsData>(queries.map.MAP_USER_RESULTS, {
    variables: { user: user?.id },
    skip: !user?.id,
  });

  useEffect(() => {
    if (user?.id) {
      refetch();
    }
  }, [user, refetch]);

  if (!loading && (!data?.mapUserResults || !data.mapUserResults.length)) {
    return <div>Plans not found</div>;
  }
  if (loading) return <Loader />;

  const getActions = (item: MapResult) => {
    return [
      <Link key={`link-${item.id}`} to={`/plan/${item.plan}/${item.id}`}>
        View
      </Link>,
    ];
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Card>
            <List
              grid={{ gutter: 16, column: 2, xs: 1, lg: 2, xl: 3, xxl: 4 }}
              dataSource={data?.mapUserResults}
              pagination={{
                onChange: (page: number) => {
                  console.log(page);
                },
                pageSize: 10,
              }}
              renderItem={(item: MapResult) => (
                <List.Item>
                  <Card
                    hoverable
                    cover={<Image alt="" src={item.snapshot} style={imageStyle} />}
                    actions={getActions(item)}>
                    <Card.Meta
                      title={(item.planTitle || '').toUpperCase()}
                      description={<p>{item.map?.address || 'Address is empty'}</p>}
                      style={{ minHeight: 100 }}
                    />
                  </Card>
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};
